import React from 'react'
import { useState,useEffect } from 'react'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { ReactComponent as SendIcon} from '../../../../images/icons/send.svg'
import Messages from './messages/index'
import ChatFunctions from '../../../../functions/public/chat'
import Top from './top';
import Input from '../../../../components/public/footer/chatbox/input';

const ChatBox = ({selectedRoom}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [messages,setMessages] = useState([]);
    const [connection, setConnection] = useState();
    
    useEffect(()=>{
        setConnection();
        setMessages([]);
        ChatFunctions.Messages(selectedRoom.id,0,setMessages);
        const connection = new HubConnectionBuilder()
        .withUrl("https://api.kaay.pk/hubs/chat")
        .configureLogging(LogLevel.Information)
        .build();
        setConnection(connection)
    },[selectedRoom])
    useEffect(()=>{
        if(connection){
            (async ()=>{
                connection.on("ReceiveMessage", (message) => {
                    setMessages(messages => [message,...messages])
                });
                await connection.start();
                if(selectedRoom.isUserA){
                    await connection.invoke("JoinRoom", { 
                        id : selectedRoom.id,
                        usera : selectedRoom.userid,
                        userb : User.id
                    });
                }
                else{
                    await connection.invoke("JoinRoom", { 
                        id : selectedRoom.id,
                        usera : User.id,
                        userb : selectedRoom.userid
                    });
                }
            })();
        }
    },[connection])
  return (
    <>
    {selectedRoom.id == 0 &&
        <div className='fullchatbox_chatempty_wrapper'>
            <div className='fullchatbox_chatempty_container'>
                <div className='fullchatbox_chatempty_image'>
                    <SendIcon />
                </div>
                <h3>Your Messages</h3>
                <p>Send private photos and messages to a friend</p>
            </div>
        </div>
    }
    {selectedRoom.id != 0 &&
        <div className='fullchatbox_conversation_wrapper'>
            <div className='fullchatbox_conversation_top'>
                <Top openChatBox={selectedRoom} />
            </div>
            <div className='fullchatbox_conversation_container'>
                <Messages openChatBox={selectedRoom} messages={messages} />
            </div>
            <div className='fullchatbox_conversation_input'>
                <Input openChatBox={selectedRoom} connection={connection}/>
            </div>
        </div>
    }
    </>
  )
}

export default ChatBox
